import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../../services/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const validToken = /^[a-f0-9]{64}$/.test(token);
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading || !validToken) return;
    setError("");
    if (password.length < 6 || password.length > 64 ||
        /\s/.test(password) || new TextEncoder().encode(password).length > 72) {
      setError("Mật khẩu phải dài 6–64 ký tự, không có khoảng trắng.");
      return;
    }
    if (password !== confirmation) {
      setError("Mật khẩu xác nhận chưa trùng khớp.");
      return;
    }

    setLoading(true);
    try {
      await api.post("/admins/reset-password", { token, password });
      setSuccess(true);
      // Remove the one-time reset token from the browser address bar.
      window.history.replaceState(null, "", "/reset-password");
    } catch (err) {
      const code = err.response?.data?.code || err.response?.data?.message;
      setError(code === "RESET_TOKEN_INVALID_OR_EXPIRED"
        ? "Liên kết không hợp lệ, đã hết hạn hoặc đã được sử dụng. Vui lòng yêu cầu liên kết mới."
        : code === "TOO_MANY_REQUESTS"
          ? "Bạn gửi quá nhiều yêu cầu. Vui lòng thử lại sau."
          : "Không thể đặt lại mật khẩu lúc này. Vui lòng thử lại.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 flex items-center justify-center min-h-screen px-4">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">Ji miso</h1>
        <h2 className="text-lg text-center text-gray-700 mb-4">Đặt lại mật khẩu quản trị</h2>
        {success ? (
          <p role="status" className="text-sm text-green-700 mb-4">
            Mật khẩu đã được đổi. Hãy đăng nhập lại và xác thực email như bình thường.
          </p>
        ) : !validToken ? (
          <p role="alert" className="text-sm text-red-700 mb-4">
            Liên kết đặt lại mật khẩu không hợp lệ. Vui lòng yêu cầu liên kết mới.
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <label htmlFor="new-admin-password" className="block text-gray-600 mb-1">Mật khẩu mới</label>
            <input
              id="new-admin-password"
              type="password"
              autoComplete="new-password"
              minLength={6}
              maxLength={64}
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <label htmlFor="confirm-admin-password" className="block text-gray-600 mb-1">Xác nhận mật khẩu</label>
            <input
              id="confirm-admin-password"
              type="password"
              autoComplete="new-password"
              minLength={6}
              maxLength={64}
              required
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {error && <p role="alert" className="text-sm text-red-700 mt-3">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#34699A] text-white px-4 py-2 rounded-md mt-4 hover:bg-[#9EC6F3] disabled:opacity-50"
            >
              {loading ? "Đang đặt lại..." : "Đặt lại mật khẩu"}
            </button>
          </form>
        )}
        <Link to={success ? "/login" : "/forgot-password"}
          className="block mt-4 text-sm text-blue-600 underline text-center">
          {success ? "Quay lại đăng nhập" : "Yêu cầu liên kết mới"}
        </Link>
        {!success && <Link to="/login" className="block mt-2 text-sm text-blue-600 underline text-center">Quay lại đăng nhập</Link>}
      </div>
    </div>
  );
}
